(function () {
  /* This script is loaded from both difference-gallery.liquid and image-banner.liquid
     (the latter reuses the .difference-gallery__discover sweep-hover button style).
     On pages where both sections appear, the tag is included twice — without this
     guard, every button would get duplicate click/hover listeners, and the discover
     toggle would immediately re-collapse itself (two listeners firing per click:
     one expands, the next sees it's now expanded and collapses it again). */
  if (window.__differenceGalleryInit) return;
  window.__differenceGalleryInit = true;

  /* Force gallery videos to start playing as early as possible. Before a video
     actually begins, browsers show a native centered "overlay play button" on
     the poster/first frame — this eliminates that idle window so the button
     never appears (the CSS also hides the overlay button as a fallback). */
  function kickstartVideos() {
    document.querySelectorAll('.difference-gallery__video').forEach(function (v) {
      // Set muted as a property (not just the attribute) — browsers require this
      // for reliable programmatic autoplay.
      v.muted = true;
      v.setAttribute('muted', '');
      var media = v.closest('.difference-gallery__media');
      var cover = media && media.querySelector('[data-video-cover]');
      var reveal = function () {
        if (cover) cover.classList.add('is-hidden');
      };
      var attempt = function () {
        v.muted = true;
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      };
      attempt();
      v.addEventListener('loadeddata', attempt, { once: true });
      v.addEventListener('canplay', attempt, { once: true });
      /* Only lift the poster cover once the video is genuinely playing, so the
         native start-playback button is never visible in the gap before that. */
      v.addEventListener('playing', reveal);
      v.addEventListener('timeupdate', function () {
        if (v.currentTime > 0) reveal();
      });
      if (!v.paused && v.currentTime > 0) reveal();
      // Resume smoothly whenever the video scrolls back into view.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { attempt(); }
            else { try { v.pause(); } catch (err) {} } // pause off-screen: only the visible video decodes
          });
        }, { threshold: 0.1 }).observe(v);
      }
    });
    // Resume when the tab regains focus (browsers pause video in hidden tabs).
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      document.querySelectorAll('.difference-gallery__video').forEach(function (v) {
        v.muted = true;
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
    });

    /* Fallback for browsers/modes that block muted autoplay (e.g. Safari Low
       Power Mode): start every gallery video on the very first user gesture
       anywhere on the page — a mouse move or scroll is enough, so it feels
       automatic. Runs once, then removes itself. */
    var gestureEvents = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll', 'mousemove'];
    function playAllOnce() {
      document.querySelectorAll('.difference-gallery__video').forEach(function (v) {
        v.muted = true;
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
      gestureEvents.forEach(function (ev) { window.removeEventListener(ev, playAllOnce); });
    }
    gestureEvents.forEach(function (ev) {
      window.addEventListener(ev, playAllOnce, { passive: true });
    });
  }
  kickstartVideos();

  /* Pause every gallery video before the page is frozen into the back/forward cache,
     so a mobile "back" doesn't restore several looping videos decoding at once — a
     common cause of the page freezing on restore. They resume via the per-video
     IntersectionObserver above once the restored page is shown/scrolled. */
  window.addEventListener('pagehide', function () {
    document.querySelectorAll('.difference-gallery__video').forEach(function (v) {
      try { v.pause(); } catch (err) {}
    });
  });

  document.querySelectorAll('[data-difference-gallery]').forEach(function (section) {
    section.querySelectorAll('[data-play-toggle]').forEach(function (btn) {
      var panel = btn.closest('[data-panel]');
      var video = panel && panel.querySelector('[data-video]');
      if (!video) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });

      /* Video may autoplay on load (no click), loop, or be paused/resumed by the
         browser (e.g. tab backgrounded) independent of the button click above —
         syncing to the actual playing/pause events keeps the icon accurate in
         every case, not just the ones triggered by this button. */
      video.addEventListener('play', function () {
        btn.classList.add('is-playing');
      });

      video.addEventListener('pause', function () {
        btn.classList.remove('is-playing');
      });

      if (!video.paused) {
        btn.classList.add('is-playing');
      }
    });
  });

  /* Sweep-hover Discover buttons: not scoped to [data-difference-gallery] since this
     button style/animation is reused on other sections (e.g. the image banner hero,
     and the footer's Client Care / The Company link lists) that render a
     .difference-gallery__discover-style link without the gallery wrapper. */
  document.querySelectorAll('.difference-gallery__discover, .footer__client-care-link').forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      link.classList.remove('is-sweeping-out');
      void link.offsetWidth;
      link.classList.add('is-sweeping-in');
    });

    link.addEventListener('mouseleave', function () {
      link.classList.remove('is-sweeping-in');
      void link.offsetWidth;
      link.classList.add('is-sweeping-out');
    });

    link.addEventListener('animationend', function (e) {
      if (e.animationName === 'discover-sweep-out') {
        link.classList.remove('is-sweeping-out');
      }
    });
  });

  /* Mobile scroll-driven colour FILL (Dior-style): the video card's text is pinned
     dead-centre by native CSS (position:sticky) while the video scrolls up and a compact
     white band is revealed behind it. As the video's lower edge — the video/white seam —
     sweeps up through the pinned text, we set each text element's --fill to the % of it
     still ABOVE the seam (over the video). The CSS paints white above that split and grey
     below via background-clip:text, so letters fill exactly at the seam: a glyph on the
     edge is half white / half grey. We only ever write a CSS variable — never the
     position (native sticky owns the pin) — so it stays perfectly smooth, no jitter.
     The CSS that reads --fill is mobile-only, so this is inert on desktop. */
  (function initScrollFill() {
    var panel = document.querySelector('.difference-gallery__panel--video');
    if (!panel) return;
    var media = panel.querySelector('.difference-gallery__media');
    var els = panel.querySelectorAll(
      '.difference-gallery__eyebrow, .difference-gallery__headline-line, .difference-gallery__discover'
    );
    var discover = panel.querySelector('.difference-gallery__discover');
    if (!media || !els.length) return;

    function paint() {
      // The video/white boundary in viewport px (rises as you scroll up).
      var seamY = media.getBoundingClientRect().bottom;
      // Read every rect first, then write, so we never thrash layout mid-loop.
      var rects = [];
      for (var i = 0; i < els.length; i++) rects[i] = els[i].getBoundingClientRect();
      for (var j = 0; j < els.length; j++) {
        var r = rects[j];
        // Fraction of this element still above the seam: 1 = all white, 0 = all grey.
        var f = r.height ? (seamY - r.top) / r.height : 1;
        if (f < 0) f = 0; else if (f > 1) f = 1;
        els[j].style.setProperty('--fill', (f * 100).toFixed(2));
      }
      // The Discover underline sits ~4px below the text; fill it by its OWN crossing of
      // the seam over an 8px soft band, so it crossfades white->grey smoothly in step.
      if (discover) {
        var dr = discover.getBoundingClientRect();
        var band = 3;
        var uY = dr.bottom + 4;
        var uf = (seamY - (uY - band / 2)) / band;
        if (uf < 0) uf = 0; else if (uf > 1) uf = 1;
        discover.style.setProperty('--uline', (uf * 100).toFixed(2));
      }
    }

    /* Drive it from a continuous rAF loop (not just scroll events) while the card is in
       view: iOS fires scroll events sparsely during momentum, which would let the colour
       lag the native-smooth pinned text; a per-frame loop keeps the fill locked to the
       seam every frame. An IntersectionObserver pauses the loop when the card is off. */
    var running = false;
    var rafId = 0;
    function loop() {
      paint();
      if (running) rafId = requestAnimationFrame(loop);
    }
    function start() {
      if (running) return;
      running = true;
      rafId = requestAnimationFrame(loop);
    }
    function stop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
      }, { rootMargin: '100px 0px' }).observe(panel);
    } else {
      window.addEventListener('scroll', paint, { passive: true });
    }
    window.addEventListener('resize', paint, { passive: true });
    paint();
  })();
})();
